import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Input,
  Modal,
  ModalFooter,
} from "@/components/ui";
import { parseMoneyInputToCents } from "@/lib/money";

const AMOUNT_ID = "receipt-manual-amount";

interface ReceiptManualAmountModalProps {
  isSubmitting: boolean;
  onSubmit: (totalCents: number) => void;
  onClose: () => void;
}

export function ReceiptManualAmountModal({
  isSubmitting,
  onSubmit,
  onClose,
}: ReceiptManualAmountModalProps) {
  const { t: tCommon } = useTranslation("common");
  const { t } = useTranslation("components");
  const [amount, setAmount] = useState("");
  const [error, setError] = useState<string>();

  const handleSubmit = () => {
    const cents = parseMoneyInputToCents(amount);
    if (cents == null || cents <= 0) {
      setError(t("receiptManualAmountInvalid"));
      return;
    }
    setError(undefined);
    onSubmit(cents);
  };

  return (
    <Modal
      closeLabel={tCommon("close")}
      isOpen
      onClose={onClose}
      title={t("receiptManualAmountTitle")}
      description={t("receiptManualAmountSubtitle")}
      size="sm"
      priority="high"
      showCloseButton={!isSubmitting}
      footer={
        <ModalFooter>
          <Button
            variant="primary"
            onClick={handleSubmit}
            isLoading={isSubmitting}
          >
            {t("receiptManualAmountSubmit")}
          </Button>
          <Button variant="outline" onClick={onClose} disabled={isSubmitting}>
            {tCommon("cancel")}
          </Button>
        </ModalFooter>
      }
    >
      <Input
        id={AMOUNT_ID}
        label={t("receiptManualAmountLabel")}
        type="text"
        inputMode="decimal"
        value={amount}
        onChange={(e) => {
          setAmount(e.target.value);
          setError(undefined);
        }}
        placeholder={t("receiptManualAmountPlaceholder")}
        error={error}
      />
    </Modal>
  );
}
